import { useNavigate } from "react-router-dom";
import React, { useContext, useState } from "react";
import { AuthContext } from "../../../context/AuthContext";
import { makeId } from "../../../util/idGenerator";
import { createPatient } from "../../../db/users";
import Container from "../../../ui/Container/Container";
import Questionary from "../../Questionaries/Questionary/Questionary";
import InitialPatientAgreement from "../InitialPatientAgreement/InitialPatientAgreement";
import Modal from "../../../ui/Modal/Modal";
import { createRange } from "../../../util/arraysUtil";

function CreatePatient() {
  const authCtx = useContext(AuthContext);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [patientData, setPatientData] = useState(null);
  const [newPatientId, setNewPatientId] = useState("");
  const [isAgreed, setIsAgreed] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  async function saveInitialQuestionary(userAnswers) {
    setIsLoading(true);
    const patientId = makeId(7);
    const firstName = userAnswers.find((a) => a.key === 0).answer;
    const secondName = userAnswers.find((a) => a.key === 1).answer;
    const name = userAnswers.find((a) => a.key === 2).answer;
    const patientFullName = `${firstName} ${secondName} ${name}`;
    let nInitials = patientFullName
      .split(/\s/)
      .reduce((response, word) => (response += word.slice(0, 1)), "")
      .split("");
    const patientInitials = nInitials.join("");
    const answersLength = userAnswers.length;
    const initDate = new Date(userAnswers.find((a) => a.key === 15).answer);
    const followDate = new Date();
    followDate.setDate(initDate.getDate() + 20);
    const endDate = new Date();
    endDate.setDate(initDate.getDate() + 70);
    const womacRange = createRange(16, 40);
    let womacSum = 0;
    womacRange.forEach((i) => {
      const ansValue = parseInt(userAnswers.find((a) => a.key === i).answer[0]);
      womacSum += ansValue;
    });

    const followDateElement = {
      answer: followDate,
      key: answersLength,
      question: "Fecha de seguimiento de Tx:",
      type: "date",
    };
    const endDateElement = {
      answer: endDate,
      key: answersLength + 1,
      question: "Fecha de fin de Tx:",
      type: "date",
    };
    const womacElement = {
      answer: womacSum.toString(),
      key: answersLength + 2,
      question: "Escala WOMAC:",
      type: "open",
    };
    userAnswers.push(followDateElement);
    userAnswers.push(endDateElement);
    userAnswers.push(womacElement);
    const patientToSave = {
      [patientId]: {
        key: patientId,
        patientInitials,
        patientName: patientFullName,
        patientAgreed: false,
        patientPrivacyAgreed: true,
        patientCreatedAt: new Date(),
        consentmentAcceptedAt: null,
        initialAnsweredAt: null,
        followAnsweredAt: null,
        finalAnsweredAt: null,
        abandonCompletedAt: null,
        isInitialCompleted: true,
        isFollowCompleted: false,
        isFinalCompleted: false,
        isPatientAbandon: false,
        forceFollowContinuity: false,
        forceFinalContinuity: false,
        patientInitDate: initDate,
        followDate,
        endDate,
        initWomac: womacSum,
        questionaries: {
          initial: {
            answers: userAnswers,
          },
        },
      },
    };

    try {
      await createPatient(patientToSave, authCtx.userId, authCtx.token);
      setNewPatientId(patientId);
      setPatientData(patientToSave);
      setIsLoading(false);
      setIsModalVisible(true);
    } catch (error) {
      alert(
        "¡Falla de registro!",
        "No se ha podido completar el registro del paciente, revisa los datos."
      );
    }
  }

  async function onOptionChosen(option) {
    if (option) {
      alert("Aceptaste el aviso de privacidad para pacientes.")
      setIsAgreed(true);
    } else {
      alert("Debes aceptar el aviso de privacidad para ingresar a la información del paciente.")
      navigate("/mainDoctor");
    }
  }

  if (isLoading) {
    return <p>Cargando...</p>
  }

  if (isAgreed) {
    return (
      <>
        <Modal isOpen={isModalVisible} onClose={() => {
          setIsModalVisible(false);
          navigate("/mainDoctor");
        }}>
          <div style={{ margin: "10px" }}>
            <p style={{ color: "white", fontSize: "20px" }}>
              El paciente se ha creado exitosamente
            </p>
            <br />
            <p style={{ color: "white", fontSize: "20px" }}>
              La escala WOMAC es:{" "}
              {patientData &&
                patientData[newPatientId] &&
                patientData[newPatientId].initWomac}
            </p>
          </div>
        </Modal>
        <Container title="Nuevo paciente" backNavigation="/mainDoctor">
          <Questionary
            questionaryId={"initial"}
            token={authCtx.token}
            onSaveQuestionary={saveInitialQuestionary}
          />
        </Container>
      </>
    );

  } else {
    return (
      <InitialPatientAgreement onOptionChosen={onOptionChosen} />
    )
  }
}

export default CreatePatient;
